import Marionette from 'backbone.marionette';
import StoryItemview from './story_itemview';
import storyCompositviewTmpl from '../templates/story_compositview.tpl';
export default Marionette.CompositeView.extend({
  template: storyCompositviewTmpl,
  childView: StoryItemview,
  childViewContainer: "#story_list"
});